<template>
    <div class="row market-rowGas">
        <div class="control-sectionGfuture">
            <h5 id="gasTitle">Gas Futures</h5>
            <div class="form-row form-row-gas">
                <div class="form-group col-md-3">
                    <ejs-dropdownlist ref="dplTradablePeriodGas" id='tradablePeriod' name="tradablePeriod" :change='onPeriodGas' :index="selectDefault" :enabled="true" floatLabelType="Always" :dataSource='tradablePeriods' :fields="{text: 'name', value: 'id' }" placeholder="Tradeable Period"></ejs-dropdownlist>
                </div>
                <div class="form-group col-md-3">
                    <ejs-dropdownlist ref='dplYearGas' id="yearGas" name="yearGas" :enabled="true" :change='onYearGas' :index="selectDefault" v-model="selectedYearGas" :dataSource='yearGas' placeholder="Period Name" floatLabelType='Always'></ejs-dropdownlist>
                </div>
            </div>
            <div id="noDataGas" ref="noDataGas" class="chartGasNoData" align='center'>
                <img src="../../../../public/img/NoData.jpg" />
            </div>
            <div class="chartGas" align='center'>
                <ejs-stockchart id="stockchartcontainerGas"
                                height='450px'
                                width="83%"
                                ref="schGas"
                                :primaryXAxis="primaryXAxis"
                                :primaryYAxis="primaryYAxis"
                                :crosshair="crosshair"
                                :title="title"
                                :tooltip="tooltip"
                                :enableSelector="enableSelector"
                                :trendlineType="trendlineType"
                                :indicatorType="indicators"
                                :seriesType="seriesType"
                                :theme="theme">
                    <e-stockchart-periods>
                        <e-stockchart-period intervalType="Months" interval="1" text="1M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Months" interval="3" text="3M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Months" interval="6" text="6M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Years" interval="1" text="1Y" selected="true"></e-stockchart-period>
                        <e-stockchart-period text="YTD"></e-stockchart-period>
                        <e-stockchart-period text="All"></e-stockchart-period>
                    </e-stockchart-periods>
                    <e-stockchart-series-collection>
                        <e-stockchart-series :dataSource="seriesDataGas" type="Spline" xName='date' yName="price" fill="#485696"></e-stockchart-series>
                    </e-stockchart-series-collection>
                </ejs-stockchart>
            </div>
            <div id="gasFuture" class="gasFuture">
                <ejs-grid id="gasFutureGrid"
                          :dataSource="mppdGasRates"
                          ref="gasFutureRatesGrid"
                          class="gas-rates"
                          :allowPaging="true"
                          :allowRowDragAndDrop="false"
                          :allowResizing="true"
                          :selectionSettings="selection"
                          :queryCellInfo='customiseCell'
                          :pageSettings='pageSettings'
                          :rowDataBound="rowDataBoundGas"
                          :rowSelected='rowSelectedGas'
                          :toolbarClick='toolbarClickGas'
                          :toolbar='toolbarOptionsGas'
                          :selectedRowIndex=0>
                    <e-columns>
                        <e-column field='id' :disableHtmlEncode='false' headerText='Id' :width="100" :visible="false" textAlign='Left'></e-column>
                        <e-column field='flag' :disableHtmlEncode='false' headerText='' textAlign='Left' :valueAccessor="valueAccessPower" width="30px" :allowResizing="false" ></e-column>
                        <e-column field='priceAreaName' :disableHtmlEncode='false' headerText='' textAlign='Left' minWidth="100px" width="120px"></e-column>
                        <e-column field='newPrice' :disableHtmlEncode='false' headerText='' textAlign='Center' width="115px"></e-column>
                        <e-column field='difference' :disableHtmlEncode='false' headerText='' textAlign='Center' width="120px"></e-column>
                        <e-column field='percentageDiff' headerText='' :disableHtmlEncode='false' textAlign='Center' width="120px"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div id="hiddenDivGas" style="display: none;" class="__web-inspector-hide-shortcut__">
                <ejs-grid id="chartHiddendataGas"
                          :dataSource="chartHiddenSourceGas"
                          ref="chartHiddenGridGas"
                          :allowPaging="true"
                          :pageSettings='pageSettings'
                          :allowExcelExport='true'
                          :visible="false">
                    <e-columns>
                        <e-column field='id' :disableHtmlEncode='false' headerText='Id' :isPrimaryKey='true' :visible="false" textAlign='Left'></e-column>
                        <e-column field='ricName' :disableHtmlEncode='false' headerText='Ric' textAlign='Left' width="100px"></e-column>
                        <e-column field='priceAreaName' :disableHtmlEncode='false' headerText='State - Price Area' textAlign='Left' width="120px"></e-column>
                        <e-column field='productName' :disableHtmlEncode='false' headerText='Product' textAlign='Left' width="120px"></e-column>
                        <e-column field='periodName' :disableHtmlEncode='false' headerText='Period' textAlign='Left' width="120px"></e-column>
                        <e-column field='date' :disableHtmlEncode='false' headerText='Date' :format='dateFormatOptions' type="date" textAlign='Left' width="120px"></e-column>
                        <e-column field='price' :disableHtmlEncode='false' headerText='Price' textAlign='Left' width="100px"></e-column>
                        <e-column field='tradingUnitName' :disableHtmlEncode='false' headerText='Unit' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import { GridPlugin, Page, Selection, RowDD, Toolbar, ExcelExport, Resize } from "@syncfusion/ej2-vue-grids";
    import apis from '@/common/network';
    import urls from '@/common/urls';
    import dates from '@/common/dates';
    import periodConversion from '@/common/periodConversion';
    import orderGrid from '@/common/orderGridFutureGas';
    import {
        StockChartPlugin, DateTime, CandleSeries, RangeTooltip, LineSeries, SplineSeries,
        HiloOpenCloseSeries, HiloSeries, RangeAreaSeries, Trendlines, EmaIndicator, RsiIndicator, BollingerBands,
        TmaIndicator, MomentumIndicator, SmaIndicator, AtrIndicator, Crosshair, AccumulationDistributionIndicator, MacdIndicator, StochasticIndicator, Export, Tooltip
    } from "@syncfusion/ej2-vue-charts";
    import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import SyncHelper from '@/common/syncfusion';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(GridPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(StockChartPlugin);
    Vue.use(DropDownListPlugin);

    let selectedTheme = location.hash.split("/")[1];
    selectedTheme = selectedTheme ? selectedTheme : "Material";
    let theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark");

    export default Vue.extend({
        created() {
            this.populateYearsGas("Calendar", "Gas");
           
        },
        data: function () {
            return {
                mppdDateVal: dates.addDays(new Date(), -7),
                selectedRic: 1,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                gasRatesFuture: [],
                mppdGasRates: [],
                seriesDataGas: [],
                gasRatesData: [],
                mppdPowerRates: [],
                yearGas: [],
                chartHiddenSourceGas:[],
                selectDefault: 0,
                selectedYearGas: 0,
                toolbarOptionsGas: ['Export Data'],
                selection: { type: 'Multiple' },
                theme: theme,
                pageSettings: { pageSize: 8 },
                //Initializing Primary X Axis
                primaryXAxis: {
                    visible: true,
                    valueType: 'DateTime'
    

                },
                //Initializing Primary Y Axis
                primaryYAxis:
                {
                    visible: true,
                    majorTickLines: { color: "transparent", width: 0 },
            
                },

                enableSelector: true,
                trendlineType: [],
                indicators: [],
                seriesType: [],
                theme: 'Bootstrap',
                tooltip: {
                    enable: true, header: ' ',
                    format: '<b>${point.x} : ${point.y}</b>'
                },

                crosshair: { enable: true },
                chartArea: {
                    border: {
                        width: 0
                    }
                },
                //width: "80%",
                //height: '250px',
                title: " ",
                palettes: ["#001c55", "#001c55", "#001c55", "#4d4d4d"]
            };
        },
        provide: {
            stockChart: [
                DateTime, Crosshair, RangeTooltip, LineSeries, SplineSeries, CandleSeries, HiloOpenCloseSeries, HiloSeries, RangeAreaSeries, Trendlines, EmaIndicator, RsiIndicator,
                BollingerBands, TmaIndicator, MomentumIndicator, SmaIndicator, AtrIndicator, AccumulationDistributionIndicator, MacdIndicator, StochasticIndicator, Export, Tooltip
            ],
            grid: [Page, Selection, RowDD, Toolbar, ExcelExport, Resize]
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '100',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            this.fetchMarketPricingPerDayDataGas();
        },
        methods: {
            toolbarClickGas: function (args) {

                if (args.item.id === "gasFutureGrid_Export Data") { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
                    let excelExportProperties = {
                        fileName: "Export Chart Gas Futures.xlsx",
                        theme:
                        {
                            header: {
                                fontName: 'Arial', fontColor: '#001c55'
                            },
                            record: {
                                fontName: 'Arial', fontColor: '#4d4d4d'
                            },
                            caption: {
                                fontName: 'Arial', fontColor: '#4d4d4d'
                            }
                        }

                    };
                    this.$refs.chartHiddenGridGas.excelExport(excelExportProperties);
                }
            },
            onYearGas: function (args) {
                var product = "Gas"

                if (this.$refs.gasFutureRatesGrid.getSelectedRows()[0]) {
                    this.selectedRic = parseInt(this.$refs.gasFutureRatesGrid.getSelectedRows()[0].cells[0].innerText);
                }

                const ricId = this.selectedRic;
               
                    if (ricId != undefined && args.itemData) {
                    var splitPeriod = args.itemData.value.split('-');


                    var indicatorSplit = splitPeriod[0];
                    var indicator = "";
                    if (indicatorSplit.includes("Q")) {
                        indicator = indicatorSplit;
                    } else {
                        indicator = periodConversion.convertPeriod(indicatorSplit);
                    }


                    const year = parseInt(new Date().getFullYear().toString().slice(0, 2) + splitPeriod[1]);
                    this.fetchMarketPricingPerDayDataGas(indicator, product,year);
                    this.fetchGasDataChart(ricId, indicator, year, product);
                }


            },
            valueAccessPower: function (field, data, column) {
                if (data.state == "Germany") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Germany.svg"/></div>`;
                }
                if (data.state == "Austria") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Austria.svg"/></div>`;
                }
                if (data.state == "Italy") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Italy.svg"/></div>`;
                }
                if (data.state == "Belgium") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Belgium.svg"/></div>`;
                }
                if (data.state == "France") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/France.svg"/></div>`;
                }
                if (data.state == "United Kingdom") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/GBP.svg"/></div>`;
                }
                if (data.state == "Spain") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Spain.svg"/></div>`;
                }
                if (data.state == "Czech Rep.") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Czech Rep.svg"/></div>`;
                }
                if (data.state == "Netherlands") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Netherlands.svg"/></div>`;
                }
                if (data.state == "Hungary") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Hungary.svg"/></div>`;
                }
                if (data.state == "Slovakia") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Slovakia.svg"/></div>`;
                }
                if (data.state == "Switzerland") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Switzerland.svg"/></div>`;
                }
                if (data.state == "Poland") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/PL.svg"/></div>`;
                }
                if (data.state == "Denmark") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/DK.svg"/></div>`;
                }
                if (data.state == "Sweden") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Sweden.svg"/></div>`;
                }
                if (data.state == "Norway") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Norway.svg"/></div>`;
                }
                if (data.state == "Finland") {
                    return `<div class="image"><img class="border-flag" src="/img/flag/Finland.svg"/></div>`;
                }
  
            },

            onPeriodGas: function (args) {

                var period = this.$refs.dplYearGas;

                var indicator = '';
                var product = "Gas";
                if (args.itemData.name == 'Calendar') {
                    indicator = 'Y';
                    period.ej2Instances.placeholder = "Select Year"
                }
                if (args.itemData.name == 'Month') {
                    indicator = 'M';
                    period.ej2Instances.placeholder = "Select Month"
                }
                if (args.itemData.name == 'Quarter') {
                    indicator = 'Q';
                    period.ej2Instances.placeholder = "Select Quarter"
                }
                if (args.itemData.name == 'Season') {
                    indicator = 'S';
                    period.ej2Instances.placeholder = "Select Season"
                }
             
                this.populateYearsGas(args.itemData.name, product);

                var period = this.$refs.dplYearGas.ej2Instances.itemData;
                var splitPeriod = period.split('-');

                const year = parseInt(new Date().getFullYear().toString().slice(0, 2) + splitPeriod[1]);

                this.fetchMarketPricingPerDayDataGas(indicator, product, year);
                this.fetchGasDataChart(this.selectedRic, indicator, year, product);


            },

            populateYearsGas: function (indicator, product) {
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`utils/productYearFut?indicator=${indicator}&product=${product == undefined ? "Gas" : product}&date=${this.mppdDateVal.toISOString().split('T')[0]}`)
                    .then(response => {
                        let temp = [];
                        for (var i = 0; i < response.data.length; i++) {
                            if (response.data[i].name == "Calendar") {
                                response.data[i].name = "CAL"
                            }

                            if (response.data[i].periodName == "Month" || response.data[i].periodName == "Season") {
                                response.data[i].name = response.data[i].name.slice(0, 3);
                            }
                            var yearString = response.data[i].year.toString();
                            var yearSlice = yearString.slice(2);
                            var name = response.data[i].name + "-" + yearSlice;

                            temp.push(name);
                        }
                        this.yearGas = temp;

                        if (this.selectedYearGas == 0) {
                            setTimeout(() => {
                                this.selectedYearGas = this.yearGas[0];
                            }, 1000)
                           
                        }
                        hideSpinner(document.getElementById('mainSpinner'));
                    }).catch(e => {
                        hideSpinner(document.getElementById('mainSpinner'));
                    });

            },

            rowSelectedGas: function (args) {
                var product = 'Gas';
                var period = this.$refs.dplYearGas.ej2Instances.itemData;
                var splitPeriod = period.split('-');


                var indicatorSplit = splitPeriod[0];
                var indicator = "";
                if (indicatorSplit.includes("Q")) {
                    indicator = indicatorSplit;
                } else {
                    indicator = periodConversion.convertPeriod(indicatorSplit);
                }


                const year = parseInt(new Date().getFullYear().toString().slice(0, 2) + splitPeriod[1]);

                this.fetchGasDataChart(args.data.id, indicator, year, product);

            },

            rowDataBoundGas: function (args) {
 
                if (args.row.ariaRowIndex == "0") {
                    var product = 'Gas';

                    var indicator = "Calendar"
                    var year = new Date().getFullYear() + 1;

                    this.fetchGasDataChart(args.data.id, indicator, year, product);

                }

            },

            customiseCell: function (args) {

                if (args.data.difference > 0) {
                    if (!args.data.difference.includes("+") && !args.data.percentageDiff.includes("+")) {
                        args.data.difference = "+" + args.data.difference;
                        args.data.percentageDiff = "+" + args.data.percentageDiff + "%";
                    }
                    args.cell.classList.add("above-0");

                } else if (args.data.difference < 0) {
                    args.cell.classList.add("below-0");

                    if (!args.data.difference.includes("%") && !args.data.percentageDiff.includes("%")) {
                        var item = args.data.percentageDiff + "%";
                        args.data.percentageDiff = item;
                    }


                } else {

                    args.cell.classList.add('same-0');
                    if (!args.data.difference.includes("%") && !args.data.percentageDiff.includes("%")) {
                        var item = args.data.percentageDiff + "%";
                        args.data.percentageDiff = item;
                    }

                }
            },
            groupBy(arr, keyFunction) {
                const groups = {};
                arr.forEach(function (el) {
                    const key = keyFunction(el);
                    if (key in groups === false) {
                        groups[key] = [];
                    }
                    groups[key].push(el);
                });
                return groups;
            },
            // if diff is a positive number, it's an increase, otherwise it's a decrease
            calculatePercentageDiff(oldValue, newValue) {
                var diff = newValue - oldValue;
                return (diff / oldValue) * 100;
            },
            getFieldName: function (fieldName, data) {
                if (fieldName === "state") {
                    return data.state
                } else if (fieldName === "difference") {
                    return data.difference;
                } else if (fieldName === "percentageDiff") {
                    return data.percentageDiff + " " + "%";
                } else if (fieldName === "id") {
                    return data.id;
                } else if (fieldName === "newPrice") {
                    return data.newPrice;
                }
            },
            checkPermissionOnUser: function () {

                if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.Update"]) {

                        this.$refs.gasFutureRatesGrid.ej2Instances.toolbarModule.toolbar.element.hidden = true;
                    }

            },
            fetchGasDataChart(id, indicator, year, product) {
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`${urls.apiBaseUrl}MarketPricingPerDay/FromDateChart?date=${this.mppdDateVal.toISOString().split('T')[0]}&id=${id}&indicator=${indicator}&year=${year}&product=${product}`).then(fxr => {
                    let temp = [];
                    let tempChartGas = [];
                    
                    for (var i = 0; i < fxr.data.result.length; i++) {
                        temp.push(fxr.data.result[i]);

                        let chartRateGas = {

                            id: fxr.data.result[i].ricId,
                            ricName: fxr.data.result[i].fullRicName,
                            stateName: fxr.data.result[i].stateName,
                            priceAreaName: fxr.data.result[i].priceAreaName,
                            productName: fxr.data.result[i].productName,
                            periodName: fxr.data.result[i].periodSpanName == null ? fxr.data.result[i].periodName : fxr.data.result[i].periodSpanName,
                            price: fxr.data.result[i].price.toFixed(3),
                            tradingUnitName: fxr.data.result[i].tradingUnitName,
                            date: new Date(fxr.data.result[i].date)
                        }
                        tempChartGas.push(chartRateGas);
                    }
                    if (temp.length == 0) {
                        this.$refs.schGas.$el.style.display = "none";
                        document.getElementById("noDataGas").style.display = "block";

                    } else {
                        this.$refs.schGas.$el.style.display = "block";
                        document.getElementById("noDataGas").style.display = "none";
                    }
                 
                    this.seriesDataGas = temp;
                    this.chartHiddenSourceGas = tempChartGas;
               
                    hideSpinner(document.getElementById('mainSpinner'));
                }).catch(
                    hideSpinner(document.getElementById('mainSpinner'))
                );



            },
            fetchMarketPricingPerDayDataGas(indicator, product, year) {
                this.checkPermissionOnUser();
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`${urls.apiBaseUrl}MarketPricingPerDay/FromDateMarket?date=${this.mppdDateVal.toISOString().split('T')[0]}&year=${year}&indicator=${indicator == undefined ? "Y" : indicator}&product=${product == undefined ? "Gas" : product}`).then(mppd => {
                    let mppdGrouped = this.groupBy(mppd.data.result, mp => mp.ricId);
                    this.mppdGasRates = [];
                    const mppdArray = Object.keys(mppdGrouped).map(ricId => {
                        return {
                            ricId,
                            mppdGroups: mppdGrouped[ricId]
                        }
                    });

                    for (const mppdObj of mppdArray) {
                        if (mppdObj.mppdGroups.length >= 2) {
                            let mppdGroupedByPeriodSpanName = this.groupBy(mppdObj.mppdGroups, mp => mp.periodSpanName);

                            const mppdGroupedByPeriodSpanNameArray = Object.keys(mppdGroupedByPeriodSpanName).map(year => {
                                return {
                                    year,
                                    mppdGroups: mppdGroupedByPeriodSpanName[year]
                                }
                            });

                            for (let mppdGroupedByPeriodSpanNameObj of mppdGroupedByPeriodSpanNameArray) {
                                if (mppdGroupedByPeriodSpanNameObj.mppdGroups.length >= 2) {
                                    // todo: should check for current year and the next year, if available
                                    let oldMppdRate = mppdGroupedByPeriodSpanNameObj.mppdGroups[mppdGroupedByPeriodSpanNameObj.mppdGroups.length - 2];
                                    let newMppdRate = mppdGroupedByPeriodSpanNameObj.mppdGroups[mppdGroupedByPeriodSpanNameObj.mppdGroups.length - 1];

                                    let mppdRate = {
                                        id: newMppdRate.ricId,
                                        state: newMppdRate.stateName,
                                        priceAreaName: newMppdRate.priceAreaName,
                                        product: newMppdRate.productName,
                                        difference: (newMppdRate.price - oldMppdRate.price).toFixed(3),
                                        newPrice: newMppdRate.price.toFixed(3) + " " + newMppdRate.currencySymbol + "/" + newMppdRate.tradingUnitName,
                                        percentageDiff: (this.calculatePercentageDiff(oldMppdRate.price, newMppdRate.price)).toFixed(2),
                                        currencySymbol: newMppdRate.currencySymbol,
                                        tradingUnitName: newMppdRate.tradingUnitName

                                    }
                               
                                    if (!this.mppdGasRates.some(r => r.id === mppdRate.id)) {
                                            this.mppdGasRates.push(mppdRate);
                                            

                                        }
                                    
                                }
                            }

                        }
                    }
                    //This is for Alba order, on grid not possible for now do that on backend
                    var orderGas = orderGrid.orderGridGas(this.mppdGasRates);
                    this.mppdGasRates = orderGas;
                    hideSpinner(document.getElementById('mainSpinner'));
                }).catch(
                    //response => { this.handleError(response); }
                    hideSpinner(document.getElementById('mainSpinner'))
                );
            },

        },
        computed: {

            tradablePeriods() {
                return SyncHelper.getDataManager("utils/Tradableperiods");
            },

        }

    });
</script>
<style>
    #gasFutureGrid.e-grid .e-gridheader {
        border-bottom-style: solid;
        border-bottom-width: 0px;
        border-top-style: solid;
        border-top-width: 0px;
    }

    #gasFutureGrid.e-grid {
        border-style: none;
        border-radius: 0px;
 
    }

    .form-row-gas {
        display: flex;
        margin: 0px 5px 0px 5px;
    }

    .fx-price-padding {
        padding-top: 30px;
    }
    .market-rowGas {
        display: flex;
        background-color: white;
        padding-top: 30px;
        height: 1055px;
        width: 34%;
        padding: 25px 30px 35px 30px;
    }
    .e-btn-group-gas {
        margin: 0px 6px 20px 6px;

    }
    .control-sectionGfuture {
        border: 1px solid lightgrey;
        border-radius: 5px;
        padding: 0px 10px 0px 0px;
        width: 100%;
    }
    #gasTitle{
        padding: 10px 20px 0px 10px;
    }
    .btn-category{
        width: auto!important;
    }

    #stockchartcontainerGas_stock_border {
        border: 0px solid rgb(221, 221, 221) !important;
    }
    .gasFuture .e-grid.e-gridhover tr[role='row']:not(.e-editedrow):hover .e-rowcell:not(.e-cellselectionbackground):not(.e-active):not(.e-updatedtd):not(.e-indentcell) {
        cursor: pointer;
    }
    .parentMarket {
        width: 100% !important;
    }
    #gasFutureGrid_Export\ Data {
        background-color: #4d4d4d;
        border: 1px solid #4d4d4d;
        color: #fff;
    }
        #gasFutureGrid_Export\ Data .e-tbar-btn-text {
            color: #fff !important;
        }

    #gasFutureGrid_Export\ Data:hover {
        background-color: #5d5d5d;
        border-color: #575757;
        -webkit-box-shadow: none;
        box-shadow: none;
        color: #fff;
    }

    .__web-inspector-hide-shortcut__ {
        display: none !important;
    }
    #noDataGas{
        display: none;
    }
    .e-toolbar-right > div:nth-child(3) {
        display: none !important;
    }

</style>